import React, {useState, useEffect} from 'react';
import Section from '../shared/Section';
import Table from '../shared/Table';
import {httpGet} from '../shared/Config';
import MoneyFormat from '../shared/MoneyFormat'
import DateFormat from '../shared/DateFormat'
import moment from 'moment';
import SimpleModal from "../shared/SimpleModal";
import { Button} from 'reactstrap';
import {useTranslation} from "react-i18next";

function PaymentBreakdown({isOpen, id, onClose, title, total, currency}) {

    const [itemsList, setItemList] = useState([]);
    const {t} = useTranslation();
    const [working, setWorking] = useState(false);

    useEffect(() => {
        if(isOpen && id != null){
            async function getPurchases() {
                const response = await httpGet(`/shoppingCart/getConfirmedItems/${id}`);
                    if(response?.data) {
                        setItemList(response.data);
                    }
            }
            getPurchases();
        }
    }, [isOpen, id]);

    function onCloseMessage() {
        setItemList([]);
        onClose();
    }

    return (
        <SimpleModal isOpen={isOpen}>
            <h3>
                {t(title)}
            </h3>
            <hr className='m-5' />
            {
                itemsList.length > 0 ? <React.Fragment>
                    {
                        itemsList.map((item,i) => (
                            <div key={i.id} >
                                <div className='flex items-center flex-1'>                                    
                                    {t(item.translateTag)}
                                    <br/> 
                                    {t('AMOUNT_OF')}: {item.amount}
                                    <br/>
                                    {t('Amount')}: <MoneyFormat>{item.totalCostIva}</MoneyFormat> {currency}                                
                                </div>
                                <hr className='m-5' />
                            </div>
                            ))
                    }
                    {t('TOTAL_PRICE')} <MoneyFormat>{total}</MoneyFormat> {currency}   
                </React.Fragment> : <React.Fragment>
                    {t('NO_BREAKDOWN')}
                    <br/>
                    <hr className='m-5' />
                </React.Fragment>
            }
            <div className={'modal-action'}>
                <Button color="primary" onClick={onCloseMessage}>{t('CLOSE')}</Button>
            </div>
        </SimpleModal>
    )

}

export default PaymentBreakdown;
